// Education grade levels (ระดับชั้น) for Wannasorn learner forms.
// Value is the stored code (mp_gradeLevel); text is the Thai label shown in the UI.
export const gradeLevelList = () => [
  { value: "GRADE_1", text: "ประถม 1" },
  { value: "GRADE_2", text: "ประถม 2" },
  { value: "GRADE_3", text: "ประถม 3" },
  { value: "GRADE_4", text: "ประถม 4" },
  { value: "GRADE_5", text: "ประถม 5" },
  { value: "GRADE_6", text: "ประถม 6" },
  { value: "GRADE_7", text: "มัธยม 1" },
  { value: "GRADE_8", text: "มัธยม 2" },
  { value: "GRADE_9", text: "มัธยม 3" },
  { value: "GRADE_10", text: "มัธยม 4" },
  { value: "GRADE_11", text: "มัธยม 5" },
  { value: "GRADE_12", text: "มัธยม 6" },
];

const ELEMENTARY_GRADES = ["GRADE_1", "GRADE_2", "GRADE_3", "GRADE_4", "GRADE_5", "GRADE_6"];

// biobeam (1000003) and appliedphysics (1000002) only offer secondary levels.
const SECONDARY_ONLY_COMPANY_IDS = [1000002, 1000003];

export const gradeLevelListByCompany = (companyId) => {
  if (SECONDARY_ONLY_COMPANY_IDS.includes(Number(companyId))) {
    return gradeLevelList().filter((g) => !ELEMENTARY_GRADES.includes(g.value));
  }
  return gradeLevelList();
};

// Resolve a stored code to its Thai label (falls back to the raw value, then "-").
export const gradeLevelText = (value) => {
  const found = gradeLevelList().find((option) => option.value === value);
  return found ? found.text : value || "-";
};
